<template>
  <div>
    <h1>Every 2 weeks on Thursday at 10:00 AM</h1>
    <div class="d-flex flex-column" style="gap: 10px">
      <v-card
        max-width="1200"
        class="shadcard"
        v-for="(post, index) in posts"
        :key="post.uid"
      >
        <div
          class="pa-4"
          style="
            display: grid;
            grid-template-columns: 40px 40px auto 80px;
            align-items: center;
            gap: 10px;
          "
        >
          <v-avatar
            size="30"
            color="primary"
            class="d-flex justify-center align-center"
            ><span style="font-size: 12pt" class="text-white">{{
              index + 1
            }}</span></v-avatar
          >
          <v-icon>mdi-drag</v-icon>
          <div>
            <h2>
              {{ post.title }}
            </h2>
            <div
              style="font-size: 10pt; color: #666"
              class="d-flex align-center mt-2"
            >
              <v-icon class="mr-2" size="small" color="muted"
                >mdi-calendar</v-icon
              >
              Thursday, December 5, 2025
              <v-icon class="ml-4 mr-2" size="small" color="muted"
                >mdi-clock</v-icon
              >
              10:00 AM
            </div>
          </div>
          <v-chip color="info" variant="flat" size="small">Scheduled</v-chip>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      category: (state) => state.categories.category,
      posts: (state) => state.posts.posts,
    }),
  },
};
</script>

<style lang="scss" scoped>
.shadcard {
  border: 1px solid hsl(214.3 31.8% 91.4%);
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.chipbg {
  background: hsl(210 40% 96.1%);
  color: hsl(222.2 47.4% 11.2%);
}
</style>
